import { ColumnsType } from 'antd/lib/table';
import config from 'config';
import { addDays, format } from 'date-fns';
import { DvmExamListSort, DvmExamOutput } from 'gql/types';
import { ExpandableNotes } from 'modules/common/components/ExpandableNotes';
import { getTranslation } from 'utils/getTranslation';

import ActionsCell from './ActionsCell';

const t = getTranslation('donor.DvmExamTable');

type Props = {
  updateDvmExamHandler: (data: DvmExamOutput) => void;
  removeDvmExamHandler: (id: string) => void;
};

export const getColumns = ({
  updateDvmExamHandler,
  removeDvmExamHandler,
}: Props): ColumnsType<DvmExamOutput> => [
  {
    title: t('examinationDate'),
    key: DvmExamListSort.ExaminationDate,
    render: (row: DvmExamOutput) =>
      format(new Date(row.examinationDate), config.DATE_FORMATS.DATE),
    defaultSortOrder: 'descend',
    align: 'center',
    sorter: true,
  },
  {
    title: t('veterinarian'),
    render: (row: DvmExamOutput) =>
      `${t(row.performedBy.firstName)} ${t(row.performedBy.lastName)}`,
    align: 'center',
  },
  {
    title: t('dueDate'),
    render: (row: DvmExamOutput) =>
      format(
        addDays(
          new Date(row.examinationDate),
          config.VALIDITY_PERIODS.DVM_EXAM_DURATION_DAYS
        ),
        config.DATE_FORMATS.DATE
      ),
    align: 'center',
  },
  {
    title: t('notes'),
    key: 'notes',
    width: 200,
    render: (row: DvmExamOutput) => (
      <ExpandableNotes notes={row.notes || '-'} rows={2} />
    ),
    align: 'center',
  },
  {
    title: t('actions'),
    render: (dvmExam: DvmExamOutput) => {
      return (
        <ActionsCell
          dvmExam={dvmExam}
          removeHandler={() => removeDvmExamHandler(dvmExam.id)}
          updateHandler={() => updateDvmExamHandler(dvmExam)}
        />
      );
    },
    align: 'center',
  },
];
